/**
 * Client-side settings API module — replaces settings.action.ts Server Actions.
 */

import { SETTINGS } from "@/shared/constants/backend-api"
import { authFetchJson } from "@/shared/lib/auth-fetch"
import { ApiResponse } from "@/shared/types/backend-response.type"
import { TwoFactAuthFormType } from "../schemas/two-fact-auth-form.schema"
import { SettingsResponse } from "../types/settings.type"
import { NotificationSettingsFormType } from "../schemas/setting-notifications-form.schema"
import { SettingVerifyCodeFormType } from "../schemas/setting-verify-code-form.schema"

// ---------------------------------------------------------------------------
// Query keys
// ---------------------------------------------------------------------------

export const SETTINGS_QUERY_KEYS = {
  all: ["settings"] as const,
  detail: (userId: number) => ["settings", userId] as const,
}

// ---------------------------------------------------------------------------
// Read
// ---------------------------------------------------------------------------

export async function getSettings(
  userId: number,
): Promise<ApiResponse<SettingsResponse>> {
  return authFetchJson<SettingsResponse>(SETTINGS.byId(userId))
}

// ---------------------------------------------------------------------------
// Mutations
// ---------------------------------------------------------------------------

export async function setupTwoFactAuth(
  userId: number,
  data: TwoFactAuthFormType,
): Promise<ApiResponse<TwoFactAuthFormType>> {
  return authFetchJson<TwoFactAuthFormType>(SETTINGS.setupTwoFactAuth(userId), {
    method: "POST",
    body: JSON.stringify(data),
  })
}

export async function updateNotifications(
  userId: number,
  data: NotificationSettingsFormType,
): Promise<ApiResponse<NotificationSettingsFormType>> {
  return authFetchJson<NotificationSettingsFormType>(SETTINGS.byId(userId), {
    method: "PUT",
    body: JSON.stringify(data),
  })
}

export async function verifyTwoFactAuthCode(
  userId: number,
  data: SettingVerifyCodeFormType,
): Promise<ApiResponse<SettingVerifyCodeFormType>> {
  return authFetchJson<SettingVerifyCodeFormType>(SETTINGS.verifyTwoFactAuthCode(userId), {
    method: "POST",
    body: JSON.stringify(data),
  })
}
